import { editBenefitModel } from "../../../infrastructure/repository/benefit-models-repository";
import { displayBenefitPage } from "../../benefit-model/displays/display-benefit-page";
import { showErrorMessage } from "../../commons/show-error-message";
import { translate } from "../../../infrastructure/translate/localization";

export default async function renameBenefitPlan({ name, benefitPlan }) {
  // TODO: adapt benefitPlan to receive all attributes from creation and adapt this delivery of data
  try {
    await editBenefitModel(benefitPlan.id, { name: name.trim() });
  } catch (e) {
    showErrorMessage(
      translate(
        "v2.feedback-messages.errors.changes-could-not-be-saved-message"
      )
    );
  }

  displayBenefitPage();
}
